import endpoint from '../util/endpoint';
import conectionDebug from './conectionDebug';
import Connection from './connection';

const bus = new Connection({
    name: 'checkout',
    url: ({ storeGuid }) => storeGuid && endpoint('cashier.cashierSignalR', { storeGuid }).url,
    dependencies: { storeGuid: (url) => url.params.storeGuid },
});
bus.options.debug = conectionDebug;
export default bus;
